export const defaultBreadcrumbSubTitle = [
    {
        text: 'You can set breadcrumb using ',
        code: '.breadcrumb '
    },
    {
        text: ' class.'
    }
]

export const dividerBreadcrumbSubTitle = [
    {
        text: 'You can set breadcrumb using ',
        code: '.breadcrumb-icon'
    },
    {
        text: ' class.'
    }
]

export const withIconBreadcrumbSubTitle = [
    {
        text: 'You can set icons breadcrumb using ',
        code: '.breadcrumb '
    },
    {
        text: 'class.'
    }
]

export const simpleBreadcrumbSubTitle = [
    {
        text: 'Breadcrumb with page name'
    }
];

export const breadcrumbAlignmentSubTitle = [
    {
        text: 'Breadcrumb alignment ',
        code: '.justify-content-*'
    },
    {
        text: ' class.'
    }
]

export const colorBreadcrumbSubTitle = [
    {
        text: 'Breadcrumb class and set background ',
        code: 'bg-* '
    },
    {
        text: 'class.'
    }
];

export const breadcrumbAlignmentData = [
    { id: 1, align: 'start', color: 'primary' },
    { id: 2, align: 'center', color: 'danger' },
    { id: 3, align: 'end', color: 'success' },
]

export const coloredBreadcrumbData = [
    {
        id: 1,
        color: 'primary mb-1',
        item: ['Home', 'Ui Kits', 'Avatars']
    },
    {
        id: 2,
        color: 'secondary mb-0',
        item: ['Home', 'Ui Kits', 'Dropdown']
    }
]